export const ICreateShareLinkUseCaseType = Symbol('ICreateShareLinkUseCase');
